import { useContext } from "react"
import { UploadResults } from "src/component/UploadResults"
import UserContext from "src/provider/state-manager/userProvider"

export const EditResult = ({setEditResult}: {setEditResult: Function}) => {
    const { user } = useContext(UserContext)

    return (
        <UploadResults user={user} isEditResult setEditResult={setEditResult} />
    )
}
